import React from 'react'
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons'
import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  useDeleteFaResidualValueChangeMutation,
  useGetDocNumTitleQuery,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { useContext, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory } from 'react-router'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'

export const ResidualValueEntryList = (props: any) => {
  const {
    filteredList,
    listLoading,
    listStatus,
    fetchMore,
    setOriginalListing,
  } = props
  const {
    handleClick,
    anchorEl,
    menu,
    handleClose,
    resetMenu,
  } = useMenuOption()
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [deleteDialog, setDeleteDialog] = useState(false)
  const history = useHistory()
  const CompanyID = localStorage.getItem('latestCompany')
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, RefTable: 'fa_residual_value' },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const docNumChecker = getDocumentNumberHeader?.length === 0

  const [
    deleteResidualValueChange,
    { loading: deleteLoading },
  ] = useDeleteFaResidualValueChangeMutation({
    onError: ({ message }) => {
      const error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
      setDeleteDialog(false)
      resetMenu()
    },
    onCompleted: data => {
      if (data?.DeleteFAResidualValueChange) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.deleteRecord())
        setDeleteDialog(false)
        setOriginalListing([])
        resetMenu()
        fetchMore({
          variables: {
            CompanyID: CompanyID,
            StatusArr: [listStatus],
            take: 30,
            skip: 0,
            searchValue:
              getSearch?.name === '' || getSearch?.name === undefined
                ? undefined
                : getSearch?.name,
          },
        })
      }
    },
  })

  const handleDelete = () => {
    if (menu?.obj?.residual_value_change_id) {
      deleteResidualValueChange({
        variables: {
          residual_value_change_id: menu.obj.residual_value_change_id,
        },
      })
    }
  }
  const { handlePermDisabled } = usePermissionChecker()

  return (
    <>
      {listLoading && <Loading />}
      {deleteLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      <ContentWrapper advSearch float>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length || 0}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name !== '' && getSearch?.name !== undefined
                        ? getSearch?.name
                        : undefined,
                  },
                })
              }}
              hasMore={props.hasMore}
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)
                ?.sort((a, b) => {
                  return (
                    Object.values(ApprovalStatus).indexOf(a?.ApprovalStatus) -
                    Object.values(ApprovalStatus).indexOf(b?.ApprovalStatus)
                  )
                })
                ?.map((el, index) => {
                  return (
                    <ListItem key={index}>
                      <ListItemText
                        primary={
                          <>
                            <span className="desc date-width">
                              {`${formatDate(el?.change_date)}` || 'N/A'}
                            </span>
                            <span className="xsTitle flex-space">
                              {el?.DocNo}
                            </span>
                            <span className={`xsTitle`}>{el?.Asset?.name}</span>
                          </>
                        }
                        secondary={
                          <>
                            <Grid container spacing={0}>
                              <Grid container className="table-content">
                                <Grid item xs={6}>
                                  <span className="desc flex-space">
                                    {el?.Asset?.Category?.name}
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  style={{ textAlign: 'right' }}
                                >
                                  <span className="desc">
                                    <span style={{ color: '#666' }}>
                                      {amtStr(el?.old_residual_amount)} |{' '}
                                      {el?.old_residual_percent}%
                                    </span>
                                    {' → '}
                                    <span style={{ color: 'orange' }}>
                                      {amtStr(el?.new_residual_amount)} |{' '}
                                      {el?.new_residual_percent}%
                                    </span>
                                  </span>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid item xs={12}>
                                  <span className="desc">{el?.reason}</span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        }
                      />

                      <ListItemSecondaryAction>
                        {listStatus === 'ACTIVE' ||
                        listStatus === 'REJECTED' ? (
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            aria-controls="menu-list"
                            aria-haspopup="true"
                            onClick={e =>
                              handleClick(
                                e,
                                el?.residual_value_change_id,
                                index,
                                el
                              )
                            }
                          >
                            <MoreVert />
                          </IconButton>
                        ) : (
                          <IconButton edge="end" aria-label="arrow">
                            <KeyboardArrowRight
                              onClick={() =>
                                history.push({
                                  pathname: `/fixed-assets/${CompanyID}/assets-change/residual-value/detail`,
                                  state: el,
                                })
                              }
                            />
                          </IconButton>
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                  )
                })}
            </InfiniteScroll>
          )}
        </List>
        {listStatus === 'ACTIVE' && (
          <FloatButton
            onClick={() => {
              if (docNumChecker) {
                setOpenSnackBar(true)
                setSnackBarMsg(SystemMsgs.errorNumberingStructure())
              } else {
                history.push(
                  `/fixed-assets/${CompanyID}/assets-change/residual-value/add`
                )
              }
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsResidualValueCreate,
            })}
          />
        )}
      </ContentWrapper>

      {listStatus === 'ACTIVE' ? (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/residual-value/edit`,
                state: menu?.obj,
              })
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsResidualValueUpdate,
            })}
          >
            <span className="">Edit</span>
          </MenuItem>
          <MenuItem
            onClick={() => setDeleteDialog(true)}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsResidualValueDelete,
            })}
          >
            <span>Delete</span>
          </MenuItem>
        </Menu>
      ) : (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/residual-value/resubmit`,
                state: { ...menu?.obj, mode: 'resubmit' },
              })
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsResidualValueUpdate,
            })}
          >
            <span className="">Resubmit</span>
          </MenuItem>
        </Menu>
      )}

      <DeleteDialog
        ID={menu?.ID}
        openDeleteDialog={deleteDialog}
        setOpenDeleteDialog={setDeleteDialog}
        title={'Residual Value Change'}
        menu={menu?.obj}
        handleDelete={handleDelete}
        passID={menu?.ID}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error'}
      />
    </>
  )
}
